import { render } from "./BackBtn.vue?vue&type=template&id=6c1005fe&scoped=true"
const script = {}

import "./BackBtn.vue?vue&type=style&index=0&id=6c1005fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1005fe"]])

export default __exports__